export const templatesConst = {
  DOWNLOAD_TEMPLATE_FILE_BEGIN: 'DOWNLOAD_TEMPLATE_FILE_BEGIN',
  DOWNLOAD_TEMPLATE_FILE_SUCCESS: 'DOWNLOAD_TEMPLATE_FILE_SUCCESS',
  DOWNLOAD_TEMPLATE_FILE_FAILED: 'DOWNLOAD_TEMPLATE_FILE_FAILED',
};
